module.exports = __webpack_public_path__ + "img/收藏@2x.247ad54c.png";